'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _oidcClient = require('oidc-client');

var _jwtDecode = require('jwt-decode');

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Auth = function Auth(options) {
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location;

  _classCallCheck(this, Auth);

  _initialiseProps.call(this);

  var basePathname = options.basePathname || '';
  this._isError = false;
  this.options = _extends({
    basePathname: basePathname,
    clientId: '' + location.origin + basePathname,
    redirectUri: '' + location.origin + basePathname + '/oidc_signin',
    postLogoutRedirectUri: '' + location.origin + basePathname + '/oidc_signout',
    silentRedirectUri: '' + location.origin + basePathname + '/oidc_renew',
    responseType: 'id_token token',
    scope: 'openid profile company permissions email recovery',
    filterProtocolClaims: true,
    automaticSilentRenew: false,
    loadUserInfo: true,
    logErrors: false
  }, options || {});

  if (this.options.clientId === 'admin') {
    this.options.clientId = 'admin:' + location.origin + basePathname;
  }

  this.userManager = new _oidcClient.UserManager(getUserManagerConfig(this.options));
  this.userManager.events.addAccessTokenExpiring(this.handleTokenExpiring);
  this.userManager.events.addUserLoaded(this.handleUserLoaded);
  this.userManager.events.addUserUnloaded(this.handleUserUnloaded);
  this.userManager.events.addUserSignedOut(this.handleUserSignedOut);
  this.locationManager = new LocationManager(this.userManager);
  this.errorManager = new ErrorManager(this.userManager);
  this.delegateManager = new DelegateManger(this.userManager);
  this.permissionsManager = new PermissionsManager(this.userManager);
  this.state = {};
};

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.signIn = function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$redirectToSignIn = _ref.redirectToSignIn,
        redirectToSignIn = _ref$redirectToSignIn === undefined ? true : _ref$redirectToSignIn,
        afterSignInPathname = _ref.afterSignInPathname;

    var address = _this.getAddress();

    var getUser = function getUser() {
      return _this.userManager.getUser().then(_this.handleGetUser({
        redirectToSignIn: redirectToSignIn,
        afterSignInPathname: afterSignInPathname
      })).catch(_this.handleError);
    }; // Silient Renewal is handled in an iframe. Don't want to try to sign in.


    if (address === _this.options.silentRedirectUri) {
      return _this.userManager.signinSilentCallback();
    } else if (address === _this.options.redirectUri) {
      return getUser();
    } else if (!_this._isError) {
      return _this.userManager.signinSilent().then(getUser).catch(getUser);
    }
  };

  this.signOut = function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        afterSignOutPathname = _ref2.afterSignOutPathname;

    _this.locationManager.save(afterSignOutPathname);

    return _this.userManager.signoutRedirect().catch(_this.handleError);
  };

  this.delegate = function (company, subject) {
    return new Promise(function (resolve, reject) {
      if (_this.userManager.settings.metadata && _this.state.accessToken) {
        var claims = _this.state.claims || {};
        var subjectHeader = base64Encode(JSON.stringify({
          alg: 'none'
        }));
        var subjectPayload = base64Encode(JSON.stringify({
          aud: _this.options.clientId,
          cmp: company,
          sub: subject || claims.sub,
          may_act: {
            aud: _this.options.clientId,
            cmp: claims.company_id,
            sub: claims.sub
          }
        }));
        var subjectToken = subjectHeader + '.' + subjectPayload + '.';
        fetch(_this.userManager.settings.metadata.token_endpoint, {
          method: 'POST',
          headers: {
            'content-type': 'application/x-www-form-urlencoded'
          },
          body: ['grant_type=urn%3Aietf%3Aparams%3Aoauth%3Agrant-type%3Atoken-exchange', '&subject_token=' + subjectToken, '&subject_token_type=urn%3Aietf%3Aparams%3Aoauth%3Atoken-type%3Ajwt', '&actor_token=' + _this.state.accessToken, '&actor_token_type=urn%3Aietf%3Aparams%3Aoauth%3Atoken-type%3Aaccess_token', '&client_id=' + encodeURIComponent(_this.options.clientId)].join('')
        }).then(function (response) {
          if (response.ok) {
            response.json().then(function (data) {
              _this.state = _extends({}, _this.state, {
                delegateCmp: company,
                delegateSub: subject || claims.sub,
                delegateToken: data.access_token
              });

              _this.delegateManager.userDelegated(_this.state);

              _this.permissionsManager.changePermissions(getPermissions(data.access_token));

              resolve();
            });
          } else {
            _this.state = _extends({}, _this.state, {
              delegateCmp: null,
              delegateSub: null,
              delegateToken: null
            });
            response.json().then(function (data) {
              reject(data);
            });
          }
        }).catch(function (err) {
          reject(err);
        });
      } else {
        // Need to wait for metadata to populate.
        setTimeout(function () {
          _this.delegate(company, subject).then(function () {
            return resolve();
          }).catch(function (err) {
            return reject(err);
          });
        }, 10);
      }
    });
  };

  this.getAddress = function () {
    var basePathname = _this.options.basePathname;
    return ('' + location.origin + basePathname + location.pathname).toLowerCase();
  };

  this.handleGetUser = function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$redirectToSignI = _ref3.redirectToSignIn,
        redirectToSignIn = _ref3$redirectToSignI === undefined ? true : _ref3$redirectToSignI,
        afterSignInPathname = _ref3.afterSignInPathname;

    return function (user) {
      var address = _this.getAddress();

      switch (address) {
        case _this.options.redirectUri.toLowerCase():
          setTimeout(function () {
            _this.userManager.signinRedirectCallback().then(_this.locationManager.restore()).catch(_this.handleError);
          }, 10);
          break;

        case _this.options.postLogoutRedirectUri.toLowerCase():
          _this.handleUserSignedOut();

          break;

        default:
          if (user && !user.expired) {
            _this.userManager.events.load(user);

            if (afterSignInPathname) {
              _this.locationManager.restore(afterSignInPathname);
            }
          } else if (redirectToSignIn) {
            _this.locationManager.save(afterSignInPathname);

            setTimeout(function () {
              _this.userManager.signinRedirect();
            }, 10);
          } else {
            _this.userManager.events.load(false);
          }

          break;
      }
    };
  };

  this.handleUserLoaded = function (user) {
    if (user) {
      _this.state = {
        idToken: user.id_token,
        accessToken: user.access_token,
        delegateCmp: null,
        delegateSub: null,
        delegateToken: null,
        claims: user.profile,
        companyUrl: user.profile ? user.profile.company_url : null
      };

      _this.permissionsManager.changePermissions(getPermissions(user.access_token));
    } else {
      _this.state = {};
    }
  };

  this.handleUserUnloaded = function () {
    _this.state = {};
  };

  this.handleTokenExpiring = function () {
    //SigninSilent will clear the state, so keep track of it before that happens.
    var hasDelegateToken = !!_this.state.delegateToken;
    var delegateCmp = _this.state.delegateCmp;
    var delegateSub = _this.state.delegateSub;

    _this.userManager.signinSilent().then(function () {
      if (hasDelegateToken) {
        _this.delegate(delegateCmp, delegateSub);
      }
    });
  };

  this.handleError = function (err) {
    _this._isError = true;

    if (_this.logErrors) {
      console.error(err);
    }

    _this.errorManager.raise(err);
  };

  this.handleUserSignedOut = function () {
    _this.userManager.removeUser().then(_this.restoreLocation).catch(_this.handleError);
  };
};

exports.default = Auth;

var LocationManager = function LocationManager(userManager) {
  var _this2 = this;

  _classCallCheck(this, LocationManager);

  this.save = function (pathname) {
    sessionStorage.setItem('bridge.returnTo', pathname || location.pathname);
  };

  this.restore = function (pathname) {
    var returnTo = pathname || sessionStorage.getItem('bridge.returnTo') || '/';
    sessionStorage.removeItem('bridge.returnTo');

    _this2.redirectEvents.forEach(function (fn) {
      fn(returnTo);
    });
  };

  this.redirectEvents = [];

  userManager.events.addRedirect = function (fn) {
    _this2.redirectEvents.push(fn);
  };

  userManager.events.removeRedirect = function (fn) {
    var index = _this2.redirectEvents.indexOf(fn);

    if (index >= 0) {
      _this2.redirectEvents.splice(index, 1);
    }
  };
};

var ErrorManager = function ErrorManager(userManager) {
  var _this3 = this;

  _classCallCheck(this, ErrorManager);

  this.raise = function (err) {
    _this3.errorEvents.forEach(function (fn) {
      fn(err);
    });
  };

  this.errorEvents = [];

  userManager.events.addError = function (fn) {
    _this3.errorEvents.push(fn);
  };

  userManager.events.removeError = function (fn) {
    var index = _this3.errorEvents.indexOf(fn);

    if (index >= 0) {
      _this3.errorEvents.splice(index, 1);
    }
  };
};

var DelegateManger = function DelegateManger(userManager) {
  var _this4 = this;

  _classCallCheck(this, DelegateManger);

  this.userDelegated = function (user) {
    _this4.delegateEvents.forEach(function (fn) {
      fn(user);
    });
  };

  this.delegateEvents = [];

  userManager.events.addUserDelegated = function (fn) {
    _this4.delegateEvents.push(fn);
  };

  userManager.events.removeUserDelegated = function (fn) {
    var index = _this4.delegateEvents.indexOf(fn);

    if (index >= 0) {
      _this4.delegateEvents.splice(index, 1);
    }
  };
};

var PermissionsManager = function PermissionsManager(userManager) {
  var _this5 = this;

  _classCallCheck(this, PermissionsManager);

  this.changePermissions = function (permissions) {
    _this5.permissionsChangedEvents.forEach(function (fn) {
      fn(permissions);
    });
  };

  this.permissionsChangedEvents = [];

  userManager.events.addPermissionsChanged = function (fn) {
    _this5.permissionsChangedEvents.push(fn);
  };

  userManager.events.removePermissionsChanged = function (fn) {
    var index = _this5.permissionsChangedEvents.indexOf(fn);

    if (index >= 0) {
      _this5.permissionsChangedEvents.splice(index, 1);
    }
  };
};

function getUserManagerConfig(options) {
  var config = {};
  var mapping = {
    'authority': 'authority',
    'clientId': 'client_id',
    'redirectUri': 'redirect_uri',
    'responseType': 'response_type',
    'scope': 'scope',
    'prompt': 'prompt',
    'display': 'display',
    'maxAge': 'max_age',
    'uiLocales': 'ui_locales',
    'loginHint': 'login_hint',
    'acrValues': 'acr_values',
    'clockSkew ': 'clockSkew',
    'loadUserInfo': 'loadUserInfo',
    'filterProtocolClaims': 'filterProtocolClaims',
    'postLogoutRedirectUri': 'post_logout_redirect_uri',
    'popupRedirectUri': 'popup_redirect_uri',
    'popupWindowFeatures': 'popupWindowFeatures',
    'popupWindowTarget': 'popupWindowTarget',
    'silentRedirectUri': 'silent_redirect_uri',
    'automaticSilentRenew': 'automaticSilentRenew',
    'silentRequestTimeout': 'silentRequestTimeout',
    'accessTokenExpiringNotificationTime': 'accessTokenExpiringNotificationTime',
    'userStore': 'userStore',
    'monitorSession': 'monitorSession',
    'checkSessionInterval': 'checkSessionInterval',
    'revokeAccessTokenOnSignout': 'revokeAccessTokenOnSignout',
    'includeIdTokenInSilentRenew': 'includeIdTokenInSilentRenew',
    'staleStateAge': 'staleStateAge'
  };
  Object.keys(mapping).forEach(function (key) {
    if (options[key] !== undefined) {
      config[mapping[key]] = options[key];
    }
  });
  return config;
}

function getPermissions(jwt) {
  if (jwt) {
    return (0, _jwtDecode2.default)(jwt).permissions || {};
  } else {
    return {};
  }
}

function base64Encode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}